const styles = {
  "genre-main": "badge badge-soft font-semibold bg-base-100 gap-1 px-3 py-3 max-w-[120px] truncate",
  "genre-sub": "badge badge-soft bg-base-100 gap-1 px-3 py-3 max-w-[120px] truncate",
  "band-type":
    "badge badge-soft font-semibold bg-pink-500/40 text-pink-300 border border-pink-500/30 gap-1 px-3 py-3",
  event:
    "badge badge-soft font-semibold bg-yellow-800/60 text-yellow-300 border border-yellow-500/30 gap-1 px-3 py-3",
  "post-blog":
    "badge badge-soft font-semibold bg-purple-800/50 text-purple-300 border border-purple-500/30 gap-1 px-3 py-3",
  "post-news":
    "badge badge-soft font-semibold bg-violet-800/50 text-violet-300 border border-violet-500/30 gap-1 px-3 py-3",
};

const Badge = ({ text, type = "genre-sub", href }) => {
  const className = styles[type] || styles["genre-sub"];

  if (href) {
    return (
      <a href={href} className={className}>
        {text}
      </a>
    );
  }

  return <span className={className}>{text}</span>;
};

export default Badge;
